import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import { changeAuthor, getTopic } from '../services/topicService'
import { Author as TopicAuthor, AuthorLite as SelectedAuthor } from '../interfaces'

/* eslint-disable import/no-internal-modules */
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@insided/deprecated-preact-components/design-system-components/modal'
import { ButtonGroup } from '@insided/deprecated-preact-components/design-system-components/button'
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import AuthorSelector from '@insided/deprecated-control/author-select/AuthorSelect'
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'

export interface ChangeAuthorProps {
  contentType: ContentType
  topicId: number
  onChangeAuthor: (author: TopicAuthor) => void
  onClose: () => void
  onShowAlert?: (type: 'success' | 'error', message?: string) => void
}

export interface ChangeAuthorState {
  isLoading: boolean
  selectedAuthor?: SelectedAuthor
  errorMessage?: string
}

class ChangeAuthorModal extends PureComponent<ChangeAuthorProps, ChangeAuthorState> {
  constructor(props: ChangeAuthorProps) {
    super(props)
    this.onSelectAuthor = this.onSelectAuthor.bind(this)
    this.onSaveChangedAuthor = this.onSaveChangedAuthor.bind(this)
  }

  onSelectAuthor(author: SelectedAuthor) {
    this.setState({ selectedAuthor: author })

    if (this.state.errorMessage) {
      this.setState({ errorMessage: undefined })
    }
  }

  async onSaveChangedAuthor() {
    const { contentType, topicId, onChangeAuthor, onClose, onShowAlert } = this.props
    const { selectedAuthor } = this.state

    if (!selectedAuthor) {
      this.setState({ errorMessage: 'Please select a user' })
      return
    }

    this.setState({ isLoading: true })

    try {
      const newAuthorId = Number(selectedAuthor.id)
      await changeAuthor(contentType, topicId, newAuthorId)

      const { author } = await getTopic(contentType, topicId)
      onChangeAuthor(author)

      onClose()
      onShowAlert?.('success', 'You’ve changed the author successfully.')
    } catch {
      onShowAlert?.('error')
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { onClose } = this.props
    const { isLoading, selectedAuthor, errorMessage } = this.state
    return (
      <Modal onClose={onClose} isControl>
        <ModalHeader title='Change author' />
        <ModalBody>
          <InputUnit label='Author' error={errorMessage}>
            <AuthorSelector
              selected={selectedAuthor}
              onChange={(author: SelectedAuthor) => this.onSelectAuthor(author)}
            />
          </InputUnit>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            {/* eslint-disable-next-line @gorazdo/preact/prefer-classname */}
            <ButtonControl title='Change author' variant='brand' onClick={this.onSaveChangedAuthor} isLoading={isLoading} class='qa-change-author' newStyle size='medium' />
            <ButtonControl title='Cancel' onClick={onClose} newStyle size='medium' />
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ChangeAuthorModal
